<template>
	<main class="container">
		<div id="div-h1">
			<h1>Associació Cultural Marrinxa</h1>
		</div>

		<div id="txt-descripcio">
			<p>
				L'associació Cutlural Marrinxa es va presentar el 16 d'abril del 2005 amb un acte a la Plaça de Santa Maria a Mataró on es va retre homenatge a la figura d'Ovidi Montllor. L'acte va comptar amb la participació de diferents col·lectius i grups artístics de diverses modalitats. Cadascú i a la seva manera van actuar per retre homenatge a l'obra del poeta valencià. Vam comptar amb la participació de Joan Rovira al càrrec d'una representació teatral. Es va col·locar una exposició de l'obra del poeta a la plaça durant tota la jornada i ens va acompanyar al sopar de Sardines i a les actuacions musicals que van portar-nos fins al final de l'acte. Els musics maresmencs que van donar inici a la nit musical van ser Whysboard Project. Seguidament, La Fera Ferotge, un grup composat per Cesk Freixas i alguns membres del grup ja dissolt Inadaptats van versionar algunes peces d'Ovidi Montllor. La Coixinera va tancar la nit amb la seva aposta musical d'arrel tradicional i ritmes del rock.
			</p>
			<p>
				Pels més curiosos, aquí teniu la imatge del cartell, com veureu el disseny i línia estètica de l'associació ha anat evolucionant al llarg dels anys!
			</p>
		</div>
	</main>
</template>

<style scoped>
	#txt-descripcio{
		margin-top: 40px;
		background: #e8e1ce;
		padding: 20px;
		text-align: justify;
	}


</style>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Marrinxa.vue